import { render, staticRenderFns } from "./MathExpressionResult.vue?vue&type=template&id=4c96218b&scoped=true&"
import script from "./MathExpressionResult.vue?vue&type=script&lang=js&"
export * from "./MathExpressionResult.vue?vue&type=script&lang=js&"
import style0 from "./MathExpressionResult.vue?vue&type=style&index=0&id=4c96218b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96218b",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QSeparator});
